import React, { useState, useEffect, useRef } from 'react';
import * as api from './api';
import AuthModal from './AuthModal';

function SettingsModal({ onClose, onUpdateUser, onThemeChange, currentTheme }) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [geminiApiKey, setGeminiApiKey] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState('');
  const [selectedTheme, setSelectedTheme] = useState(currentTheme);
  const initialTheme = useRef(currentTheme);
  const firstInputRef = useRef(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const user = await api.getUser();
        setFirstName(user.firstName || '');
        setLastName(user.lastName || '');
        setGeminiApiKey(user.geminiApiKey || '');
      } catch (err) {
        setError('Failed to fetch user data');
      }
    };
    fetchUser();
  }, []);

  useEffect(() => {
    onThemeChange(selectedTheme);
  }, [selectedTheme, onThemeChange]);

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      await api.updateUser({ firstName, lastName, theme: selectedTheme, geminiApiKey });
      initialTheme.current = selectedTheme;
      setSuccess('Profile updated successfully');
      onUpdateUser({ firstName, lastName });
      onClose();
    } catch (err) {
      setError('Failed to update profile');
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setPasswordError('');
    setPasswordSuccess('');
    if (newPassword !== confirmPassword) {
      setPasswordError('New passwords do not match');
      return;
    }
    try {
      await api.changePassword({ currentPassword, newPassword });
      setPasswordSuccess('Password changed successfully');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setPasswordError(err.message || 'Failed to change password');
    }
  };

  const handleCancel = () => {
    onThemeChange(initialTheme.current);
    onClose();
  };

  return (
    <AuthModal title="Settings" onClose={handleCancel} icon="settings" firstInputRef={firstInputRef}>
      <form onSubmit={handleProfileSubmit}>
        {error && <p className="error-message">{error}</p>}
        {success && <p className="success-message">{success}</p>}
        <input
          ref={firstInputRef}
          type="text"
          placeholder="First Name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
        <input
          type="text"
          placeholder="Last Name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
        <input
          type="text"
          placeholder="Gemini API Key"
          value={geminiApiKey}
          onChange={(e) => setGeminiApiKey(e.target.value)}
        />
        <div className="theme-switcher">
          <label>Theme</label>
          <div style={{ display: 'flex' }}>
            <button title="Switch to light theme" type="button" className={`button light-theme-button ${selectedTheme === 'light' ? 'active' : ''}`} onClick={() => setSelectedTheme('light')}>Light</button>
            <button title="Switch to dark theme" type="button" className={`button dark-theme-button ${selectedTheme === 'dark' ? 'active' : ''}`} onClick={() => setSelectedTheme('dark')}>Dark</button>
          </div>
        </div>
        <div className="modal-footer">
          <button title="Save and close" type="submit" className="button save-button">Save and close</button>
          <button title="Cancel" type="button" className="button cancel-button" onClick={handleCancel}>Cancel</button>
        </div>
      </form>

      <hr />

      <form onSubmit={handleChangePassword}>
        <h4>Change Password</h4>
        {passwordError && <p className="error-message">{passwordError}</p>}
        {passwordSuccess && <p className="success-message">{passwordSuccess}</p>}
        <input
          type="password"
          placeholder="Current Password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
        />
        <input
          type="password"
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <input
          type="password"
          placeholder="Confirm New Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        <div className="modal-footer">
          <button title="Change Password" type="submit" className="button save-button">Change Password</button>
          <button title="Cancel" type="button" className="button cancel-button" onClick={handleCancel}>Cancel</button>
        </div>
      </form>
    </AuthModal>
  );
}

export default SettingsModal;
